import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

/**
 * Хук для управления сохранённым логином в cookies
 */
export const useRememberMe = () => {
  const [login, setLogin] = useState<string>('');
  const [rememberMe, setRememberMe] = useState<boolean>(false);

  useEffect(() => {
    // Очищаем localStorage при инициализации
    // localStorage.clear(); // Убрано, так как это сбрасывает данные других компонентов


    // Проверяем, есть ли сохранённый логин
    const savedLogin = Cookies.get('rememberedLogin');
    if (savedLogin) {
      setLogin(savedLogin);
      setRememberMe(true);
    }
  }, []);

  return {
    login,
    setLogin,
    rememberMe,
    setRememberMe
  };
};
